jQuery(document).ready(function () {

	var appUrl = "https://store.xecurify.com";
	// var widgetName = document.getElementById("custom_js").getAttribute("widgetName");
	// var widgetBgcolor = document.getElementById("custom_js").getAttribute("widgetBgcolor");
	// var widgetWidth = document.getElementById("custom_js").getAttribute("widgetWidth");
	// var widgetHeight = document.getElementById("custom_js").getAttribute("widgetHeight");
	// var widgetFontcolor = document.getElementById("custom_js").getAttribute("widgetFontcolor");
	// var checkout_url = document.getElementById("custom_js").getAttribute("checkoutUrl");
	// var hostName = document.getElementById("custom_js").getAttribute("hostName");

	var widgetName = null;
	var widgetBgcolor = null;
	var widgetWidth = null;
	var widgetHeight = null;
	var widgetFontcolor = null;
	var checkout_url = null;
	var hostName = null;

	// $('head').append('<link rel="stylesheet" type="text/css" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css">');
    $('head').append('<link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/css/intlTelInput.min.css">');
    $('head').append('<script src="https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/intlTelInput-jquery.js"></script>');
    $('head').append('<script src="https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/intlTelInput-jquery.min.js"></script>');
    $('head').append('link href="https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/intlTelInput.min.js">');
	$('head').append("<form id='ShopifyLoginForm' action='https://" + window.location.hostname + "/account/login' method='POST'> " +
		'<input name="checkout_url" type="hidden" value="account">' +
		'<input name="form_type" type="hidden" value="customer_login">' +
		'<input type="text" name="customer[email]" id="member_email" value="">' +
		'<input type="password" name="customer[password]" id="member_password" value="">' +
		'<input type="submit" name="" value="" >' +
		"</form>");
	$('head').append("<form id='verifyotp' action='" + appUrl + "/moas/rest/shopify/api/auth/verifyOtp2fa' method='GET'> " +
		"<input type='text' id='txid' name='txid'></input>" +
		"<input type='text' id='mobilenumber' name='mobilenumber'></input>" +
		"<input type='text' id='otp' name='otp'></input>" +
		"<input type='text' id='shop' name='shop'></input>" +
		"<input type='text' id='shopcheckouturl' name='shopcheckouturl'></input>" +
		"</form>");
	$('head').append("<form id='ShopifyAccountRecovery' action='https://" + window.location.hostname + "/account/recover' method='POST'> " +
		'<input name="form_type" type="hidden" value="recover_customer_password">' +
		'<input type="text" name="email" id="member_email" value="">' +
		"</form>");

	// var els = document.querySelectorAll("a[href^='/account/logout']")




	// $("#MainContent").append('<div><a href="#" id="profile_update">更新登入方式</a></div>')
	// $('#customer_login').prepend('<div class=header_login id=myHeader_login><p style=text-align:center><input type=button style=cursor:pointer;background:' + widgetBgcolor + ';width:' + widgetWidth + ';height:' + widgetHeight + ';color:' + widgetFontcolor + '; class =btn btn-primary id=my_button value="切換電子郵件 或 手機號碼" onclick="popup()" style="display:none;"></p></div>');

	$('#customer_login').prepend('<div class=header_login id=myHeader_login ><p style=text-align:center><input type=button style=cursor:pointer;background:' + widgetBgcolor + ';width:' + widgetWidth + ';height:' + widgetHeight + ';color:' + widgetFontcolor + '; class =btn btn-primary id=my_button_register value="切換電子郵件 或 手機號碼" onclick="popupregister()"></p></div>');


	// $('#MainContent').append('<div id="myModal" class="modal" style="display: none;">' +

	// 	'<div class="modal-content">' +

	// 	'<span id = "closebutton" class="close">x</span>' +
	// 	'<p style="color:black;" id="mobileNumberText">輸入手機號碼或電子郵件地址</p><br>' +
	// 	'<p style="color:black;display:none" id="otpText">輸入OTP驗證碼，五分鐘內有效</p>' +
	// 	//onkeypress="if(this.value.length==10) return false;"
	// 	'<label id="plus" style="display:none">+</label>' +
	// 	'<input type="text" style="display:none;color:black;" id="countrycode" value="886">' +
	// 	'<input type="text" style="display:inline-block;color:black;" id="mobileNumber" >' +
	// 	'<input type="text" style="display:inline-block;color:black;display:none;" id="otpInput"><br>' +
	// 	'<br><input type="password" style="color:black;display:none;" id="EmailPasswordInput" placeholder="Enter Your Password"><br>' +
	// 	'<label id="mobileError" style="color:red;"></label><br>' +
	// 	'<h2 id="accountTitleHandle" style="color:black; display:none"></h2>' +
	// 	'<h6 id="accountTextHandle" style="color:#000;width:70%;margin:10px auto;"></h6>' +
	// 	'<div id="appendingTag"></div>' +
	// 	'<button id="verifyButton" class="btn" style="display:none">驗證</button><br>' +

	// 	'<span id="timer" style="color:#318cd0"></span>' +
	// 	'<div style="margin-top: 18px;"><a href="#" id="resendButton" style="display:none;">重新發送OTP驗證碼</a></div>' +

	// 	'<button id="submitButton" class="btn">切換電子郵件 或 手機號碼</button><br>' +
	// 	'<button id="LoginButton" style="display:none" class="btn">切換電子郵件 或 手機號碼</button>' +
	// 	'<button id="ResetButton" style="display:none" class="btn">忘記/重設密碼</button>' +
	// 	'</div>' +

	// 	'</div>');

	$('#MainContent').append('<div id="RegisterModal" class="modal" style="display: none;">' +

		'<div class="modal-content">' +

		'<span id = "closebuttonRegister" class="close">x</span>' +

        '<div class="d-flex justify-content-center mt-3" style="margin-bottom:10px;">' +
            '<button id="phoneOtpBtn" class="btn btn-primary mx-2" style="width:35%; margin-right:20px;" onclick="showPhoneOtp()">Phone</button>' +
            '<button id="emailOtpBtn" class="btn btn-secondary mx-2" style="width:35%" onclick="showEmailOtp()">Email</button>' +
        '</div>' +

		'<p style="color:black;" id="mobileNumberTextRegister">以手機號碼登入</p>' +

        '<p style="color:black;display:none" id="otpText">系統已發送一次性密碼至您信箱 請輸入OTP驗證碼，五分鐘內有效</p>' +
		//onkeypress="if(this.value.length==10) return false;"
		'<input type="text" style="display:none;color:black;" id="mobileNumber" >' +
		'<input type="text" style="display:inline-block;color:black;display:none;" id="otpInput">' +
		'<input type="password" style="color:black;display:none;" id="EmailPasswordInput" placeholder="Enter Your Password">' +
		'<label id="mobileError" style="color:red;"></label>' +
		'<h2 id="accountTitleHandle" style="color:black; display:none"></h2>' +
		'<h6 id="accountTextHandle" style="color:#000;width:70%;margin:10px auto;"></h6>' +
		'<div id="appendingTag"></div>' +
		'<button id="verifyButton" class="btn" style="display:none">驗證</button>' +

		'<span id="timer" style="color:#318cd0"></span>' +
		'<div style=""><a href="#" id="resendButton" style="display:none;">重新發送OTP驗證碼</a></div>' +

		'<p style="color:black;display:none" id="otpTextRegister">請輸入OTP驗證碼</p>' +
		//onkeypress="if(this.value.length==10) return false;"
		// '<label id="plusRegister" style="display:inline-block">+</label>' +
		// '<input type="text" style="display:inline-block;color:black;" id="countrycodeRegister" value="886">' +
		'<input type="text" style="display:inline-block;color:black;width:100%;" id="mobileNumberRegister" >' +
		'<input type="text" style="display:inline-block;color:black;display:none;" id="otpInputRegister"><br>' +
		'<label id="mobileErrorRegister" style="color:red;"></label><br>' +
        '<input type="text" id="email" placeholder="輸入您的電子郵件" style="display: none;" required="">' +
		'<h2 id="accountTitleHandle" style="color:black; display:none"></h2>' +
		'<h6 id="accountTextHandle" style="color:#000;width:70%;margin:10px auto;"></h6>' +
		'<div id="appendingTag"></div>' +
		'<button id="verifyButtonRegister" class="btn" style="display:none">驗證</button><br>' +

		'<span id="timer" style="color:#318cd0"></span>' +

		'<div style="margin-top: 18px;"><a href="#" id="resendButton" style="display:none;">重新發送OTP驗證碼</a></div>' +

		'<button id="submitButtonRegister" class="btn">提交</button><br>' +
        '<button id="submitButton" style="display:none" class="btn">登入</button><br>' +
		'<button id="LoginButton" style="display:none" class="btn">登入</button>' +
		'<button id="ResetButton" style="display:none" class="btn">忘記/重設密碼</button>' +
		'</div>' +

		'</div>');


	$('#MainContent').append('<div id="updateModal" class="modal" style="display: none;">' +

		'<div class="modal-content">' +

		'<span id = "closebuttonprofile" class="close">x</span>' +
		'<p style="color:black;" id="userEmailText">電子郵件</p>' +
		'<br>' +
		'<input type="text" style="display:inline-block;color:black;width:50%;" id="userEmail" >' +
		'<hr>' +
		'<p style="color:black;" id="MobileNumber">輸入手機號碼</p>' +
		'<br>' +
		'<input type="text" style="display:inline-block;color:black;width:50%" id="updateMobileNumber" >' +
		'<label id="mobileError" style="color:red;">請輸入完整國際格式電話號碼：<br>'+
'假設您的手機號碼為 0968555888<br>'+
'請移除號碼之首的 「0」加上國碼「+886」<br>'+
'輸入+886968555888</label><br>' +
		'<hr>' +

		'<button id="updatenumbersubmit" class="btn">送出</button><br>' +
		'</div>' +

		'</div>');

	var Hash_String = window.location.search;
	var CheckoutUrl = "";
	const Hash_Param = new URLSearchParams(Hash_String);
	if (Hash_Param.has('hash')) {
		// console.log('In setting hash');
		document.cookie = "storefront_digest=" + Hash_Param.get('hash') + "; path=/";
		var shop_name = window.location.hostname;
		window.location.href = "https://" + shop_name;
	}
	if (Hash_Param.has('checkout_url')) {
		CheckoutUrl = "checkout";

	}
	else {
		CheckoutUrl = checkout_url;
	}

    $.getScript("https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/intlTelInput.min.js", function () {
        flagnum = document.querySelector("#mobileNumberRegister");
        flagfield = window.intlTelInput(flagnum, ({
            separateDialCode: true,
            hiddenInput: "full_phone",
            initialCountry: "TW",
            utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
        }));
    });




	var styles = '.modal .modal-content {' +
		'box-shadow: 1px 1px 6px 1px;' +
		'background-color: #fefefe; margin: auto; padding: 20px; border: 1px solid #888; width: 40%; text-align:center;' +
		'}' +
		' #countrycode {display:none;color:black; width: 15%; }' +
		' #countrycodeRegister {display:inline-block;color:black; width: 15%; }' +

		'@media (max-width : 420px) { .modal .modal-content {' +
		'box-shadow: 1px 1px 6px 1px;' +
		'background-color: #fefefe; margin: auto; padding: 20px; border: 1px solid #888; width: 92%; text-align:center;' +
		'}'+
		' #countrycode { width: 22%; }  #countrycodeRegister { width: 22%; } }' +

		'.close {	color: #aaaaaa; float: right; position: relative; top: -16px; font-size: 28px; font-weight: bold;}' +

		'.close:hover,' +
		'.close:focus { color: #000; text-decoration: none; cursor: pointer; }' +
		'.modal { display: none; /* Hidden by default */ position: fixed; /* Stay in place */ z-index: 999999; /* Sit on top */ padding-top: 5%; /* Location of the box */ left: 0;	top: 0;	width: 100%; /* Full width */ height: 100%; /* Full height */	overflow: auto; /* Enable scroll if needed */ background-color: rgb(0,0,0); /* Fallback color */ background-color: rgba(0,0,0,0.4); /* Black w/ opacity */	opacity:1; }'
	var styleSheet = document.createElement("style");
	styleSheet.type = "text/css";
	styleSheet.innerText = styles;
	document.head.appendChild(styleSheet);
	// document.getElementById('closebutton').onclick = function () {
	// 	document.getElementById('myModal').style.display = 'none';
	// }

	document.getElementById('closebuttonprofile').onclick = function () {
		document.getElementById('updateModal').style.display = 'none';
	}


	document.getElementById('closebuttonRegister').onclick = function () {
		document.getElementById('RegisterModal').style.display = 'none';
	}

	var current_url = window.location + " ";
	if (current_url.indexOf("account") > 0 && current_url.indexOf("account/login") < 0 && current_url.indexOf("account/register") < 0) {
	//	var els1 = document.getElementById("customer_logout_link");
	//	console.log("hello");
	//	var el = document.createElement("div");
	//	el.innerHTML = '<a href="#" id="profile_update">更新配置文件</a>';

	//	els1.parentNode.insertBefore(el, els1);
		$.ajax(
			{
				url: "/apps/2fa/moas/rest/shopify/getuserinfo2fa?shop=" + window.location.hostname + "&id=" + ShopifyAnalytics.meta.page.customerId,
				type: "GET",
				headers: { 'Customer-Key': '19682', 'Timestamp': '1611582714234', 'Authorization': 'f32201d6adfd872acc19df58b606166e5e214678275998c2900a71978f1734e22bf8b71b4c0588b5d5022e497008bb9b76d182156dd4f371c1435935d517e0db' },
				success: function (result) {
					if (result.status == 'success') {
						document.getElementById("userEmail").value = result.email;
						if (result.phone) {
							document.getElementById("updateMobileNumber").value = result.phone;

						}

					}
				},
				error: function (xhr, status, p3, p4) {
					var err = "Error " + " " + status + " " + p3;
					if (xhr.responseText && xhr.responseText[0] == "{")
						err = JSON.parse(xhr.responseText).message;
					alert(err);
				}
			});



	}


	if (document.getElementById("profile_update")) {
		document.getElementById("profile_update").addEventListener('click', function () {

			document.getElementById('updateModal').style.display = 'block';
		});
	}
	document.getElementById("updatenumbersubmit").addEventListener('click', function () {
		mobileErrorHandler.innerHTML = "";
		$.ajax(
			{
				url: "/apps/2fa/moas/rest/shopify/updateuserinfo2fa?shop=" + window.location.hostname + "&id=" + ShopifyAnalytics.meta.page.customerId + "&number=" + document.getElementById("updateMobileNumber").value + "&email=" + document.getElementById("userEmail").value,
				type: "GET",
				headers: { 'Customer-Key': '19682', 'Timestamp': '1611582714234', 'Authorization': 'f32201d6adfd872acc19df58b606166e5e214678275998c2900a71978f1734e22bf8b71b4c0588b5d5022e497008bb9b76d182156dd4f371c1435935d517e0db' },
				success: function (result) {
					// console.log(result.status);
					// console.log(result);
					if (result.status == 'true') {

						// console.log("sucess");
						document.getElementById('updateModal').style.display = 'none';

					}
					else {
						mobileErrorHandler.innerHTML = "出了點問題。請稍後再試"
					}
				},
				error: function (xhr, status, p3, p4) {
					var err = "Error " + " " + status + " " + p3;
					if (xhr.responseText && xhr.responseText[0] == "{")
						err = JSON.parse(xhr.responseText).message;
					alert(err);
				}
			}
		);

	});
	var submitButtonHandle = document.getElementById('submitButton');
	let mobileNumberHandle = document.getElementById('mobileNumber');
	let emailHandle = document.getElementById('email');
	let mobileNumberTextHandle = document.getElementById('mobileNumberText')
	let otpTextHandle = document.getElementById('otpText')
	let mobileErrorHandler = document.getElementById("mobileError");
	let countrCodeHandler = document.getElementById("countrycode");
	let plusSignHandler = document.getElementById("plus");
	let otpInputHandle = document.getElementById('otpInput')
	let verifyButtonHandle = document.getElementById('verifyButton')
	var txId;
	var mobileNumber;
	var RegisterButtonHandler = document.getElementById('submitButtonRegister');
	let RegistermobileNumberHandle = document.getElementById('mobileNumberRegister');
	let RegistermobileNumberTextHandle = document.getElementById('mobileNumberTextRegister');
	let RegistermobileErrorHandler = document.getElementById("mobileErrorRegister");
	let RegisterotpInputHandle = document.getElementById('otpInputRegister')
	let RegisterverifyButtonHandle = document.getElementById('verifyButtonRegister')
	let RegisterplusSignHandler = document.getElementById("plusRegister");
	let RegisterotpTextHandle = document.getElementById('otpTextRegister');
	let EmailPasswordHandler = document.getElementById("EmailPasswordInput");
	let EmailLoginButtonHandler = document.getElementById("LoginButton");
	let ResetButtonHandler = document.getElementById("ResetButton");



	submitButtonHandle.addEventListener('click', function () {

		var phoneno = /^\d{9,11}$/;
		var emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		var email = emailHandle.value;
		

		if (email.match(emailPattern)) {
			// mobileNumberTextHandle.style = 'display:inline-block';
			// plusSignHandler.style.display = 'inline-block';
			// countrCodeHandler.style.display = 'inline-block';
			mobileErrorHandler.innerHTML = "請稍等。我們正在通過您的電子郵件發送OTP";


			$.ajax(
				{
					url: appUrl + "/moas/rest/shopify/api/auth/otprequest2fa?shop=" + window.location.hostname + "&number=" + email,
					type: "GET",
					headers: { 'Customer-Key': '19682', 'Timestamp': '1611582714234', 'Authorization': 'f32201d6adfd872acc19df58b606166e5e214678275998c2900a71978f1734e22bf8b71b4c0588b5d5022e497008bb9b76d182156dd4f371c1435935d517e0db' },
					success: function (result) {
						// console.log(result.status);
						// console.log(result);
						if (result.status == 'SUCCESS') {

							mobileErrorHandler.innerHTML = "";
							mobileNumberHandle.style = 'display:none'

							// mobileNumberTextHandle.style = 'display:none'

							emailHandle.style = 'display:none'

							submitButtonHandle.style = 'display:none'

							otpTextHandle.style = 'color:black;display:block'

							otpInputHandle.style = 'display:inline-block;color:black;'

							verifyButtonHandle.style = 'display:inline-block'
							document.getElementById("resendButton").style = 'display:inline-block';

							// console.log(result);
							txId = result.txId;

						}
						else if (result.status == 'false') {
							mobileErrorHandler.innerHTML = "此電子郵件未註冊。請先註冊您的電子郵件地址再登入";
						}
					},
					error: function (xhr, status, p3, p4) {
						var err = "Error " + " " + status + " " + p3;
						if (xhr.responseText && xhr.responseText[0] == "{")
							err = JSON.parse(xhr.responseText).message;
						alert(err);
					}
				});
		}
		else {
			var email = emailHandle.value;
			submitButtonHandle.style = 'display:none';

			// EmailPasswordHandler.style='display:inline-block';
			// EmailLoginButtonHandler.style = 'display:inline-block';
			mobileErrorHandler.innerHTML = "請稍等 。";

			$.ajax(
				{
					url: appUrl + "/moas/rest/shopify/getuserinfo2fa?shop=" + window.location.hostname + "&email=" + email,
					type: "GET",
					headers: { 'Customer-Key': '19682', 'Timestamp': '1611582714234', 'Authorization': 'f32201d6adfd872acc19df58b606166e5e214678275998c2900a71978f1734e22bf8b71b4c0588b5d5022e497008bb9b76d182156dd4f371c1435935d517e0db' },
					success: function (result) {
						if (result.status == 'success') {
							if (!result.customertags.includes("mobileotp_authentication")) {
								mobileErrorHandler.style = 'display:none';
								EmailPasswordHandler.style = 'display:inline-block';
								EmailLoginButtonHandler.style = 'display:inline-block';

							}
							else {
								EmailLoginButtonHandler.style = 'display:none';
								ResetButtonHandler.style.display = 'inline-block';
								mobileErrorHandler.innerHTML = "您已將“手機簡訊OTP身份驗證”設置為默認登入方法。如果您想將其切換回電子郵件，請單擊“重設”以重設您的帳戶密碼";
								ResetButtonHandler.addEventListener('click', function () {
									mobileErrorHandler.innerHTML = "請稍等 。";

									$.ajax(
										{
											url: appUrl + "/moas/rest/shopify/updateuserinfo2fa?shop=" + window.location.hostname + "&email=" + mobileNumberHandle.value + "&tags=mobileotp_authentication",
											type: "GET",
											headers: { 'Customer-Key': '19682', 'Timestamp': '1611582714234', 'Authorization': 'f32201d6adfd872acc19df58b606166e5e214678275998c2900a71978f1734e22bf8b71b4c0588b5d5022e497008bb9b76d182156dd4f371c1435935d517e0db' },
											success: function (result) {
												if (result.status == 'true') {

													document.getElementById('ShopifyAccountRecovery').elements.namedItem("email").value = mobileNumberHandle.value;
													document.getElementById('ShopifyAccountRecovery').submit();


												}
												else {
													mobileErrorHandler.innerHTML = "出了點問題。請稍後再試"
												}
											},
											error: function (xhr, status, p3, p4) {
												var err = "Error " + " " + status + " " + p3;
												if (xhr.responseText && xhr.responseText[0] == "{")
													err = JSON.parse(xhr.responseText).message;
												alert(err);
											}
										}
									);

								});

							}
						}
						else {
							mobileErrorHandler.innerHTML = "請確認您的電子郵件地址是否正確，或稍後再試";
							submitButtonHandle.style = 'display:inline-block';
						}
					},
					error: function (xhr, status, p3, p4) {
						var err = "Error " + " " + status + " " + p3;
						if (xhr.responseText && xhr.responseText[0] == "{")
							err = JSON.parse(xhr.responseText).message;
						alert(err);
					}
				});
		}

	});


	document.getElementById("resendButton").addEventListener('click', function () {
		mobileErrorHandler.innerHTML = "Please Wait ";
		$.ajax(
			{
				url: appUrl + "/moas/rest/shopify/api/auth/otprequest2fa?shop=" + window.location.hostname + "&number=" + document.getElementById("countrycode").value + mobileNumberHandle.value,
				type: "GET",
				headers: { 'Customer-Key': '19682', 'Timestamp': '1611582714234', 'Authorization': 'f32201d6adfd872acc19df58b606166e5e214678275998c2900a71978f1734e22bf8b71b4c0588b5d5022e497008bb9b76d182156dd4f371c1435935d517e0db' },
				success: function (result) {
					if (result.status == 'SUCCESS') {

						mobileErrorHandler.innerHTML = "";
						mobileNumberHandle.style = 'display:none'

						mobileNumberTextHandle.style = 'display:none'

						submitButtonHandle.style = 'display:none'

						countrCodeHandler.style = 'display:none'

						plusSignHandler.style = 'display:none'

						otpTextHandle.style = 'color:black;display:block'

						otpInputHandle.style = 'display:inline-block;color:black;'

						verifyButtonHandle.style = 'display:inline-block'
						document.getElementById("resendButton").style = 'display:inline-block';

						// console.log(result);
						txId = result.txId;

					}
					else if (result.status == 'false') {
						mobileErrorHandler.innerHTML = "請確認您的手機號碼是否正確，或稍後再試";
					}
				},
				error: function (xhr, status, p3, p4) {
					var err = "Error " + " " + status + " " + p3;
					if (xhr.responseText && xhr.responseText[0] == "{")
						err = JSON.parse(xhr.responseText).message;
					alert(err);
				}
			});
	});



	EmailLoginButtonHandler.addEventListener('click', function () {

		document.getElementById('ShopifyLoginForm').elements.namedItem("customer[email]").value = mobileNumberHandle.value;
		document.getElementById('ShopifyLoginForm').elements.namedItem("customer[password]").value = EmailPasswordHandler.value;
		document.getElementById('ShopifyLoginForm').submit();

	});

	RegisterButtonHandler.addEventListener('click', function () {
        phoneNumber = flagfield.getNumber();
        contact = phoneNumber.substring(1);
        if (flagfield.isValidNumber()) {
            RegistermobileErrorHandler.innerHTML = "請稍等。我們正在通過您的手機號碼發送OTP";

            $.ajax(
                {
                    url: appUrl + "/moas/rest/shopify/api/auth/otprequest2fa?shop=" + window.location.hostname + "&number=" + contact + "&action=register",
                    type: "GET",
                    headers: { 'Customer-Key': '19682', 'Timestamp': '1611582714234', 'Authorization': 'f32201d6adfd872acc19df58b606166e5e214678275998c2900a71978f1734e22bf8b71b4c0588b5d5022e497008bb9b76d182156dd4f371c1435935d517e0db' },
                    success: function (result) {
                        if (result.status == 'SUCCESS') {
                            RegistermobileErrorHandler.innerHTML = "";
                            RegistermobileNumberHandle.style = 'display:none'

                            RegistermobileNumberTextHandle.style = 'display:none'

                            RegisterButtonHandler.style = 'display:none'

                            RegisterotpTextHandle.style = 'color:black;display:block'

                            RegisterotpInputHandle.style = 'display:inline-block;color:black;'

                            RegisterverifyButtonHandle.style = 'display:inline-block'

                            var intlTelInputElement = document.querySelector('.iti--allow-dropdown');
                            if (intlTelInputElement) {
                                intlTelInputElement.style.display = 'none';
                            }

                            // console.log(result);
                            txId = result.txId;

                        }
                        else if (result.status == 'false') {
                            RegistemobileErrorHandler.innerHTML = "請確認您的手機號碼是否正確，或稍後再試";
                        }
                    },
                    error: function (xhr, status, p3, p4) {
                        var err = "Error " + " " + status + " " + p3;
                        if (xhr.responseText && xhr.responseText[0] == "{")
                            err = JSON.parse(xhr.responseText).message;
                        alert(err);
                    }
                });
        }
        else {
            alert('電話號碼無效');
        }
		

	});



	document.getElementById("verifyButton").addEventListener('click', function () {

		document.getElementById('verifyotp').elements.namedItem("txid").value = txId;
		document.getElementById('verifyotp').elements.namedItem("shop").value = window.location.hostname
		document.getElementById('verifyotp').elements.namedItem("otp").value = document.getElementById("otpInput").value
		document.getElementById('verifyotp').elements.namedItem("mobilenumber").value = emailHandle.value;
		document.getElementById('verifyotp').elements.namedItem("shopcheckouturl").value = CheckoutUrl;
		document.getElementById('verifyotp').submit();



	});

	document.getElementById("verifyButtonRegister").addEventListener('click', function () {

		document.getElementById('verifyotp').elements.namedItem("txid").value = txId;
		document.getElementById('verifyotp').elements.namedItem("shop").value = window.location.hostname
		document.getElementById('verifyotp').elements.namedItem("otp").value = document.getElementById("otpInputRegister").value
		document.getElementById('verifyotp').elements.namedItem("mobilenumber").value = contact;
		document.getElementById('verifyotp').elements.namedItem("shopcheckouturl").value = CheckoutUrl;
		document.getElementById('verifyotp').submit();



	});

	if (Hash_Param.has('txid')) {
		RegistermobileErrorHandler.innerHTML = "您輸入了無效的OTP";
        RegistermobileNumberHandle.style = 'display:none'

        RegistermobileNumberTextHandle.style = 'display:none'

        RegisterButtonHandler.style = 'display:none'

        RegisterotpTextHandle.style = 'color:black;display:block'

        RegisterotpInputHandle.style = 'display:inline-block;color:black;'

        RegisterverifyButtonHandle.style = 'display:inline-block'

		
		document.getElementById('my_button_register').click();
		setTimeout(function() {
			var intlTelInputElement = document.querySelector('.iti--allow-dropdown');
			if (intlTelInputElement) {
				intlTelInputElement.style.display = 'none';
			}
		}, 300);


		// mobileErrorHandler.innerHTML = "您輸入了無效的OTP"
		// mobileNumberHandle.style = 'display:none'

		// mobileNumberTextHandle.style = 'display:none'

		// submitButtonHandle.style = 'display:none'

		// countrCodeHandler.style = 'display:none'

		// plusSignHandler.style = 'display:none'

		// otpTextHandle.style = 'color:black;display:block'

		// otpInputHandle.style = 'display:inline-block;color:black;'

		// verifyButtonHandle.style = 'display:inline-block'
		// document.getElementById("resendButton").style = 'display:inline-block';

		// document.getElementById('my_button').click();
		
		txId = Hash_Param.get('txid');
		mobileNumberHandle.value = Hash_Param.get('mobilenumber');
		contact = Hash_Param.get('mobilenumber');
	}

});


function popup() {
	document.getElementById('myModal').style.display = 'block';
}

function popupregister() {
	document.getElementById('RegisterModal').style.display = 'block';
}

function showEmailOtp() {
    document.getElementById('mobileNumberTextRegister').textContent = '用電子郵件登入';
    document.getElementById('email').style.display = 'block';
    document.getElementById('email').style.width = '100%';
    document.getElementById('email').style.marginTop = '-50px';
    document.getElementById('mobileNumberRegister').style.display = 'none';
    var intlTelInputElement = document.querySelector('.iti--allow-dropdown');
    if (intlTelInputElement) {
        intlTelInputElement.style.display = 'none';
    }
	document.getElementById('submitButtonRegister').style.display = 'none';
	document.getElementById('submitButton').style.display = 'inline-block';
	
	// Hide OTP-related elements when switching to email
	document.getElementById('otpTextRegister').style.display = 'none';
	document.getElementById('otpInputRegister').style.display = 'none';
	document.getElementById('verifyButtonRegister').style.display = 'none';
	document.getElementById('resendButton').style.display = 'none';
	document.getElementById('mobileErrorRegister').innerHTML = '';
	
	// Clear input values
	document.getElementById('otpInputRegister').value = '';
}

function showPhoneOtp() {
    document.getElementById('mobileNumberTextRegister').textContent = '以手機號碼登入';
    document.getElementById('mobileNumberRegister').style.display = 'block';
    document.getElementById('email').style.display = 'none';
    var intlTelInputElement = document.querySelector('.iti--allow-dropdown');
    if (intlTelInputElement) {
        intlTelInputElement.style.display = 'block';
    }
	document.getElementById('submitButtonRegister').style.display = 'inline-block';
	document.getElementById('submitButton').style.display = 'none';
	
	// Hide email OTP-related elements and reset when switching to phone
	document.getElementById('otpText').style.display = 'none';
	document.getElementById('otpInput').style.display = 'none';
	document.getElementById('verifyButton').style.display = 'none';
	document.getElementById('otpTextRegister').style.display = 'none';
	document.getElementById('otpInputRegister').style.display = 'none';
	document.getElementById('verifyButtonRegister').style.display = 'none';
	document.getElementById('resendButton').style.display = 'none';
	document.getElementById('mobileError').innerHTML = '';
	document.getElementById('mobileErrorRegister').innerHTML = '';
	
	// Clear input values
	document.getElementById('otpInput').value = '';
	document.getElementById('otpInputRegister').value = '';
	document.getElementById('email').value = '';
}



// When the user clicks anywhere outside of the modal, close it
window.onclick = function (event) {
	if (event.target == document.getElementById('myModal')) {
		document.getElementById('myModal').style.display = 'none';
	}

	if (event.target == document.getElementById('updateModal')) {
		document.getElementById('updateModal').style.display = 'none';
	}

	if (event.target == document.getElementById('RegisterModal')) {
		document.getElementById('RegisterModal').style.display = 'none';
	}
}